import { CircuitBenefitType } from '@/types/circuits/CircuitBenefitType';
import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';
import { BenefitFormData } from '@/types/circuits/CircuitDaysFormData';
import { parseCircuitBenefitType } from '@/utils/circuits/parseCircuitBenefitType';
import { useCallback } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { CircuitFormData } from '@/types/circuits/CircuitFormData';

export const useCircuitBenefitRemoval = (
  days: CircuitDayFormData[],
  setValue: UseFormSetValue<CircuitFormData>,
) => {
  const removeStandardBenefit = useCallback(
    ({ stepId, type }: { stepId: string; type: CircuitBenefitType }) => {
      const circuitBenefitType = parseCircuitBenefitType(type);
      days.forEach((day, dayIndex) => {
        day.steps.forEach((dayStep, dayStepIndex) => {
          if (dayStep[circuitBenefitType]?.id === stepId) {
            setValue(
              `circuitDays.${dayIndex}.steps.${dayStepIndex}.${circuitBenefitType}.standardBenefit`,
              undefined,
            );
            if (dayStep[circuitBenefitType].optionalBenefits.length === 0) {
              setValue(
                `circuitDays.${dayIndex}.steps.${dayStepIndex}.${circuitBenefitType}.nbDays`,
                1,
              );
              setValue(
                `circuitDays.${dayIndex}.steps.${dayStepIndex}.${circuitBenefitType}.time`,
                undefined,
              );
            }
          }
        });
      });
    },
    [days, setValue],
  );

  const removeOptionalBenefits = useCallback(
    ({
      stepId,
      type,
      optionalBenefits,
      indexToRemove,
    }: {
      stepId: string;
      type: CircuitBenefitType;
      optionalBenefits: BenefitFormData[];
      indexToRemove: number;
    }) => {
      const circuitBenefitType = parseCircuitBenefitType(type);
      days.forEach((day, dayIndex) => {
        day.steps.forEach((dayStep, dayStepIndex) => {
          if (dayStep[circuitBenefitType]?.id === stepId) {
            if (
              !dayStep[circuitBenefitType].standardBenefit &&
              dayStep[circuitBenefitType].optionalBenefits.length === 1
            ) {
              setValue(
                `circuitDays.${dayIndex}.steps.${dayStepIndex}.${circuitBenefitType}.nbDays`,
                1,
              );
              setValue(
                `circuitDays.${dayIndex}.steps.${dayStepIndex}.${circuitBenefitType}.time`,
                undefined,
              );
            }
            setValue(
              `circuitDays.${dayIndex}.steps.${dayStepIndex}.${circuitBenefitType}.optionalBenefits`,
              optionalBenefits.filter((_, index) => index !== indexToRemove),
            );
          }
        });
      });
    },
    [days, setValue],
  );

  return {
    removeStandardBenefit,
    removeOptionalBenefits,
  };
};
